// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2o8Gk","footer":"styles_footer__1lgyO","passCodeTooltip":"styles_passCodeTooltip__3vB42"};